import React from "react";
import classNames from "classnames";
import settings from "../../settings";
import styles from "./index.module.css";

const IndexSelector = ({ currentIndex, onChange }) => {
  return (
    <ul
      className={classNames(
        styles.indexSelector,
        "tw-list-none tw-m-0 tw-p-0 tw-flex tw-max-w-100 tw-overflow-x-auto tw-pb-3 md:tw-pb-0"
      )}
    >
      {settings.indices.map(i => {
        return (
          <li
            key={i.index}
            className={classNames("tw-m-0 tw-whitespace-nowrap", {
              [styles.indexSelectorItem]: true,
              [styles.indexSelectorItemActive]: currentIndex.index === i.index
            })}
            onClick={() => onChange(i)}
          >
            {i.title}
          </li>
        );
      })}
    </ul>
  );
};

export default IndexSelector;
